
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"64","height":"64","fill":"#400F3F","rx":"8.258"}}),_c('path',{attrs:{"fill":"#FF4702","d":"M41.886 18.343l3.77 3.771a2.666 2.666 0 010 3.772l-3.77 3.77a2.65 2.65 0 01-.553.425v4.754c2.3.592 4 2.68 4 5.165 0 2.946-2.387 5.333-5.333 5.333S34.667 42.946 34.667 40c0-2.485 1.7-4.573 4-5.165l-.001-4.754a2.673 2.673 0 01-.552-.424l-3.77-3.771c-.17-.17-.31-.355-.425-.552h-4.754a5.34 5.34 0 01-3.831 3.831l-.001 5.501h1.334a2.667 2.667 0 012.666 2.667v5.334a2.667 2.667 0 01-2.666 2.666h-5.334a2.667 2.667 0 01-2.666-2.666v-5.334a2.667 2.667 0 012.666-2.666h1.333v-5.502a5.333 5.333 0 116.499-6.498h4.754c.114-.198.255-.384.424-.553l3.771-3.77a2.666 2.666 0 013.772 0zm-15.22 18.99h-5.333v5.334h5.334v-5.334zm13.334 0a2.667 2.667 0 100 5.334 2.667 2.667 0 000-5.334zm0-17.104L36.229 24 40 27.771 43.771 24 40 20.229zm-16 1.104a2.667 2.667 0 100 5.334 2.667 2.667 0 000-5.334z"}})])])
          )
        }
      }
    